import { render } from "./ChiTietVanBan.vue?vue&type=template&id=9ab6e4e2&scoped=true&ts=true"
import script from "./ChiTietVanBan.vue?vue&type=script&lang=ts"
export * from "./ChiTietVanBan.vue?vue&type=script&lang=ts"

import "./ChiTietVanBan.vue?vue&type=style&index=0&id=9ab6e4e2&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab6e4e2"]])

export default __exports__